import React from 'react';
import { Drawer, Typography, IconButton, Grid, Button } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import { customtheme } from '../../../app/theme/theme';

const useStyles = makeStyles((theme) => ({
  drawer: { width: 500 },
  drawerHeader: {
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.divider}`,
    background: customtheme.gray[200],
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  drawerContent: {
    overflowY: 'auto',
    padding: theme.spacing(2),
    height: '100%',
  },
  drawerFooter: {
    padding: theme.spacing(2),
    borderTop: `1px solid ${theme.palette.divider}`,
    background: customtheme.gray[200],
    display: 'flex',
    justifyContent: 'flex-end',
  },
  title: {
    color: customtheme.blue[500],
    marginBottom: theme.spacing(1),
  },
  infoLabel: {
    color: customtheme.gray[400],
    fontWeight: 600,
  },
  infoValue: {
    color: customtheme.black,
  },
  section: {
    padding: theme.spacing(1, 0),
    borderBottom: `1px dashed ${theme.palette.divider}`,
  },
}));

interface Props {
  open: boolean;
  onClose: () => void;
  record?: any | null;
}

const QuotesConsultDrawer: React.FC<Props> = ({ open, onClose, record }) => {
  const classes = useStyles();

  const InfoRow: React.FC<{ label: string; value?: any }> = ({ label, value }) => (
    <Grid container>
      <Grid item xs={5}><Typography variant="body2" className={classes.infoLabel}>{label}</Typography></Grid>
      <Grid item xs={7}><Typography variant="body1" className={classes.infoValue}>{value ?? '-'}</Typography></Grid>
    </Grid>
  );

  return (
    <Drawer anchor="right" open={open} onClose={onClose} classes={{ paper: classes.drawer }}>
        <div className={classes.drawerHeader}>
          <Typography variant="h6">Detalhes da Solicitação / Cotação</Typography>
          <IconButton onClick={onClose}><CloseIcon /></IconButton>
        </div>

        <div className={classes.drawerContent}>
          <Grid container spacing={2}>

            <Grid item xs={12} className={classes.section}>
              <Typography variant="subtitle1" className={classes.title}>Solicitação</Typography>
              {record?.solicitacao ? (
                <Grid container spacing={1}>
                  <Grid item xs={12}><InfoRow label="Nº Solicitação" value={record.solicitacao.numsol ?? record.numsol} /></Grid>
                  <Grid item xs={12}><InfoRow label="Empresa" value={record.solicitacao.nomemp} /></Grid>
                  <Grid item xs={12}><InfoRow label="Filial" value={record.solicitacao.nomfil} /></Grid>
                  <Grid item xs={12}><InfoRow label="Solicitante" value={record.solicitacao.nomususol} /></Grid>
                  <Grid item xs={12}><InfoRow label="Produto/Descrição" value={record.solicitacao.cplpro} /></Grid>
                  <Grid item xs={12}><InfoRow label="Quantidade" value={record.solicitacao.qtdsol} /></Grid>
                  <Grid item xs={12}><InfoRow label="Unidade" value={record.solicitacao.unimed} /></Grid>
                </Grid>
              ) : (
                <Typography variant="body2">Nenhuma solicitação disponível</Typography>
              )}
            </Grid>

            <Grid item xs={12} className={classes.section}>
              <Typography variant="subtitle1" className={classes.title}>Cotação</Typography>
              {record?.cotacao ? (
                <Grid container spacing={1}>
                  <Grid item xs={12}><InfoRow label="Nº Cotação" value={record.cotacao.numcot ?? record.numcot} /></Grid>
                  <Grid item xs={12}><InfoRow label="Fornecedor" value={record.cotacao.apefor} /></Grid>
                  <Grid item xs={12}><InfoRow label="Cplite" value={record.cotacao.cplite} /></Grid>
                  <Grid item xs={12}><InfoRow label="Empresa" value={record.cotacao.nomemp} /></Grid>
                  <Grid item xs={12}><InfoRow label="Data Cotação" value={record.cotacao.datcot} /></Grid>
                  <Grid item xs={12}><InfoRow label="Valor" value={record.cotacao.vlrcot} /></Grid>
                </Grid>
              ) : (
                <Typography variant="body2">Nenhuma cotação disponível</Typography>
              )}
            </Grid>
          </Grid>
        </div>

        <div className={classes.drawerFooter}>
          <Button onClick={onClose}>Voltar</Button>
        </div>
    </Drawer>
  );
};

export default QuotesConsultDrawer;
